export default __webpack_public_path__ + "assets/fonts/c6ec080084769a6d8a34ab35b77999cd.woff";